import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Logo from '../components/Logo'

export default function Login() {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setErro('')
    setLoading(true)
    const { error } = await signIn({ email, senha })
    setLoading(false)
    if (error) {
      // Email não confirmado — Supabase retorna "Email not confirmed"
      if (error.message?.toLowerCase().includes('email not confirmed') ||
          error.message?.toLowerCase().includes('not confirmed')) {
        setErro('Você precisa confirmar seu e-mail antes de fazer login. Verifique sua caixa de entrada.')
      } else {
        setErro('E-mail ou senha incorretos.')
      }
    }
    else navigate('/')
  }

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logo}><Logo size={240} /></div>
        <h1 style={s.title}>Entrar na sua conta</h1>
        <p style={s.sub}>Use o e-mail e senha cadastrados</p>
        <form onSubmit={handleSubmit}>
          <div style={s.field}><label style={s.label}>E-mail</label>
            <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required />
          </div>
          <div style={s.field}><label style={s.label}>Senha</label>
            <div style={{ position: 'relative' }}>
              <input style={{ ...s.input, paddingRight: 40 }} type={mostrarSenha ? 'text' : 'password'}
                value={senha} onChange={e => setSenha(e.target.value)} placeholder="••••••••" required />
              <button type="button" onClick={() => setMostrarSenha(!mostrarSenha)} style={s.eyeBtn} aria-label="Mostrar senha">
                {mostrarSenha ? '🙈' : '👁'}
              </button>
            </div>
          </div>
          {erro && <p style={s.erro}>{erro}</p>}
          <button style={s.btn} type="submit" disabled={loading}>{loading ? 'Entrando...' : 'Entrar'}</button>
        </form>
        <p style={s.link}><Link to="/recuperar-senha">Esqueci minha senha</Link></p>
        <p style={s.link}>Não tem conta? <Link to="/cadastro">Cadastre-se</Link></p>
      </div>
    </div>
  )
}

const s = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem', background: '#f5f5f5' },
  card: { background: 'white', borderRadius: 12, padding: '2rem', width: '100%', maxWidth: 400, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' },
  logo: { display: 'flex', justifyContent: 'center', marginBottom: '1.2rem' },
  title: { fontSize: 16, fontWeight: 500, textAlign: 'center', marginBottom: 4 },
  sub: { fontSize: 13, color: '#666', textAlign: 'center', marginBottom: '1.5rem' },
  field: { marginBottom: '1rem' },
  label: { display: 'block', fontSize: 12, color: '#666', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  eyeBtn: { position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 },
  btn: { width: '100%', padding: 12, background: '#D85A30', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 4 },
  erro: { color: '#A32D2D', fontSize: 13, background: '#FCEBEB', padding: '8px 12px', borderRadius: 8, marginBottom: 8 },
  link: { fontSize: 12, color: '#666', textAlign: 'center', marginTop: 10 },
}
